import { themeColor } from 'LibNeo'
import styled from 'styled-components'

export const NotificationWrapper = styled.div`
	position: absolute;
	right: 100px;
	top: 96px;
	padding: 42px;
	width: 400px;
	background: ${themeColor('white')};
	border: 1px solid #ebedf1;
	box-sizing: border-box;
	box-shadow: 12px 12px 32px rgba(223, 227, 232, 0.5);
	border-radius: 8px;
	z-index: 2000;
`
